import React, { useState } from 'react'
import TableContent from '../../components/TableContent'
import KnowledgeBaseItemList from '../../components/KnowledgeBaseItemList'
import { CCard } from '@coreui/react'

const url = 'process/kb'
const item = 'KnowledgeBase'
const items = 'KnowledgeBases'

const KnowledgeBase = () => {
  const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState(null)

  const handleRowSelect = record => {
    setSelectedKnowledgeBase(record ? record.id : null)
  }

  return (
    <>
      <TableContent url={url} type={'knowledgebase'} item={item} items={items} onRowSelect={handleRowSelect} />

      {selectedKnowledgeBase && (
        <CCard className="p-3 mt-3">
          <KnowledgeBaseItemList knowledgebaseId={selectedKnowledgeBase} />
        </CCard>
      )}
    </>
  )
}
export default KnowledgeBase
